module.exports = __webpack_public_path__ + "media/images/pause_mode-c86043ae067f2fa624e4a58f515294e0.png";